import React from 'react'
import createReactClass from 'create-react-class'
import LogoHeader from '../components/logo-header'
import LoginForm from '../containers/login/login-form-container'

export default createReactClass({

  render () {
    return (
      <section className='login-view-section flex-display'>
        <div className="login-view">
          <section className='login-section'>
            <LogoHeader/>
            <LoginForm {...this.props}/>
          </section>
        </div>
      </section>
    )
  },
})



// WEBPACK FOOTER //
// ./src/views/login.js